enum AppLanguage {
  PL = "PL",
  DE = "DE",
  EN = "EN",
}

export default AppLanguage;
